import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  BtnLoadingDirective,
  HeroCalendarSolid,
  HeroExclamation,
  HeroLocationMarkerSolid,
  HeroOfficeBuildingSolid,
  HeroShoppingCartSolid,
  HeroTicketSolid,
  HeroTrash,
  HeroUpload,
  HeroUsersSolid,
  TixButtonModule,
  TixCardModule,
  TixDialogModule,
  TixIconModule,
  TixIconRegistry,
  TixInputModule,
  TixPhoneNumbersAdminModule,
  BtnLoadingDirectiveModule,
  TixCommunicationsAdminModule,
  TixCheckboxModule
} from '@tix/shared/ui/components';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TextMaskModule } from 'angular2-text-mask';
import { TixCompanyCardComponent } from './company-card/company-card.component';
import { TixCompanyProfileComponent } from './profile/profile.component';

import { MatSelectModule } from '@angular/material/select';
import { TixCompanyCommunicationComponent } from './company-communication/company-communication.component';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TixInputModule,
    TixIconModule,
    TixButtonModule,
    TixCommunicationsAdminModule,
    RouterModule,
    TixCardModule,
    MatSelectModule,
    TextMaskModule,
    TixDialogModule,
    TixPhoneNumbersAdminModule,
    BtnLoadingDirectiveModule,
    MatButtonModule,
    TixCheckboxModule
  ],
  declarations: [
    TixCompanyCardComponent,
    TixCompanyProfileComponent,
    TixCompanyCommunicationComponent
  ],
  exports: [
    TixCompanyCardComponent,
    TixCompanyProfileComponent,
    MatSelectModule,
    TixCompanyCommunicationComponent
  ]
})
export class CompanyComponentsModule {
  constructor(private iconRegistry: TixIconRegistry) {
    iconRegistry.addSvgIconConfigs([
      HeroCalendarSolid,
      HeroUsersSolid,
      HeroLocationMarkerSolid,
      HeroOfficeBuildingSolid,
      HeroTicketSolid,
      HeroShoppingCartSolid,
      HeroTrash,
      HeroUpload,
      HeroExclamation
    ]);
  }
}
